import 'consumerweb-shim';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '../utility/bootstrap';
import React, { Component, Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Route, Switch, Router } from 'react-router-dom';
import history from './configureHistory';
import CookiedUserPage from './../pages/landing/landing';
import CrossBorder from './../pages/guest/crossBorder';
import {
  GuestConfirmationPending,
  GuestConfirmationSuccess,
} from '../pages/guest/confirmation';
import PaymentError from './../pages/error/paymentError';
import UnilateralError from '../pages/error/UnilateralError';
import templateData from './../utility/getTemplateData';
import { isOneTouchUser, isAuthenticatedUser } from 'utility/authUtils';
import { parseUrlQuery } from '../utility/urlUtils';
import { setShouldRTL } from '../utility/paypalAphrodite';
import { showSpinnerOverlay, hideSpinnerOverlay } from '../utility/helper';
import ThreeDSError from '../pages/error/threeDSError';
import { addTrackReportLink } from '../utility/reportLink';
import { addHandleFeedbackLink } from '../utility/feedbackLink';
import { reactLazyPreload } from '../utility/lazyLoader';

// set the direction for styles (whether to convert them to RTL)
const { locality: { directionality = 'ltr' } = {} } = templateData;
setShouldRTL(directionality !== 'rtl');
addTrackReportLink();
addHandleFeedbackLink();

const { currentUserState, isUnilateralAccount } = templateData;

const GuestPage = reactLazyPreload(() => import('./../pages/guest/guest'));

function FallbackSpinner() {
  useEffect(() => {
    showSpinnerOverlay();
  }, []);

  return <></>;
}

class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userCookied: currentUserState === 'cookied',
      isOneTouch: isOneTouchUser(),
    };
  }

  componentDidMount() {
    if (isUnilateralAccount) {
      history.push('/donate/error/noaccount');
      return;
    }
    // Only hiding spinner for cookied user
    if (this.state.userCookied) {
      // In case of onboarding, guest.js will hide the spinner
      if (!templateData.onboardingEnabled) {
        hideSpinnerOverlay();
      }
    }

    if (!isAuthenticatedUser()) {
      GuestPage.preload();
    }
  }

  getPageToRender() {
    // If `signup` param is present, render GuestPage
    const isSignupRoute = !!parseUrlQuery().signup;
    if (isSignupRoute) {
      return <GuestPage />;
    }
    return <CookiedUserPage />;
  }

  render() {
    return <div>{this.getPageToRender()}</div>;
  }
}

ReactDOM.render(
  <Router history={history}>
    <Suspense fallback={<FallbackSpinner />}>
      <Switch>
        <Route exact path="/donate" component={LandingPage} />
        <Route exact path="/donate/guest" component={GuestPage} />
        <Route exact path="/donate/guest/crossborder" component={CrossBorder} />
        <Route
          exact
          path="/donate/guest/confirmation"
          component={GuestConfirmationSuccess}
        />
        <Route
          exact
          path="/donate/guest/pending"
          component={GuestConfirmationPending}
        />
        <Route exact path="/donate/error/payment" component={PaymentError} />
        <Route
          exact
          path="/donate/error/noaccount"
          component={UnilateralError}
        />
        <Route exact path="/donate/error/threeDS" component={ThreeDSError} />
      </Switch>
    </Suspense>
  </Router>,
  document.getElementById('donateWrapper')
);
